import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '@src/app/modules/auth';

@Injectable({
  providedIn: 'root',
})
export class UnAuthGuard {
  private readonly router = inject(Router);
  private readonly session = inject(SessionService);

  async canActivate(): Promise<boolean> {
    if (this.session.isLogged()) {
      this.router.navigate(['/']);

      return false;
    }

    return true;
  }

  async canActivateChild(): Promise<boolean> {
    return this.canActivate();
  }
}
